import { ProtectedRoute } from "@/components/ProtectedRoutes";
import { Layout } from "@/components/layouts";
import usePageTracking from "@/hooks/usePageTracking";
import { Login } from "@/pages/Auth/Login";
import { ComponentTestPage } from "@/pages/ComponentTest";
import { NotFound } from "@/pages/NotFound";
import { PredictionMarketTop } from "@/pages/PredictionMarket/Top";
import { PredictionMarketDetails } from "@/pages/PredictionMarketDetails";
import { PredictionMarketChartForReactNativeWebView } from "@/pages/PredictionMarketWebView/Chart";
import { WithdrawalRecord } from "@/pages/Record";
import { PrivacyPolicy } from "@/pages/TermsAndPolicy/PrivacyPolicy";
import { TermsOfService } from "@/pages/TermsAndPolicy/TermsOfService";
import { WithdrawalHome } from "@/pages/Withdrawal";
import { Navigate, RouterProvider, createBrowserRouter } from "react-router-dom";

const TrackingWrapper = ({ children }: { children: React.ReactNode }) => {
  usePageTracking();
  return <>{children}</>;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <TrackingWrapper>
        <Layout />
      </TrackingWrapper>
    ),
    children: [
      {
        index: true,
        element: <PredictionMarketTop />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "terms-of-service",
        element: <TermsOfService />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "top",
        element: <Navigate to="/" />,
      },
      {
        path: "component-test",
        element: <ComponentTestPage />,
      },
      {
        path: "",
        element: <ProtectedRoute />,
        children: [
          {
            path: "record",
            element: <WithdrawalRecord />,
          },
          {
            path: "withdrawal",
            element: <WithdrawalHome />,
          },
        ],
      },
      {
        path: "prediction-market",
        children: [
          {
            index: true,
            element: <PredictionMarketTop />,
          },
          {
            path: "details/:predictionMarketId",
            element: <PredictionMarketDetails />,
          },
          {
            path: "",
            element: <ProtectedRoute />,
          },
        ],
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
  {
    path: "/webview/chart/:predictionMarketId",
    element: (
      <TrackingWrapper>
        <PredictionMarketChartForReactNativeWebView />
      </TrackingWrapper>
    ),
  },
]);

const Root = () => {
  return <RouterProvider router={router} />;
};

export default Root;
